import { CompanyTabPropsT } from "@interfaces/company/company";

import { SingleDocuments } from "@feature/single-documents";
import { useLocation } from "react-router-dom";
import { useSelectedCompanyQuery } from "@lib/company";

const SingleDocumentsPage: React.FC<CompanyTabPropsT> = () => {
  const { company } = useSelectedCompanyQuery();

  const { pathname } = useLocation();
  const url = pathname.split("/");

  if (!company) {
    return null;
  }

  return (
    <SingleDocuments
      type={url[2]}
      departmentId={+url[3]}
      positionId={+url[4]}
      companyId={company?.id}
    />
  );
};

export default SingleDocumentsPage;
